import React from 'react';
import styled from 'styled-components';
import ProductParam, {
  getDefaultConfigWithExtra,
  findExtraDisplayInfo,
  getProductSelectNames,
  ProductSizeParam,
} from './ProductParam';

export default function ProductConfig(props) {
  const {product, config, onChange, viewOnly} = props;
  const selectNames = getProductSelectNames(product);

  return (
    <Wrapper>
      {selectNames
        .filter(
          (selectName) =>
            !['width_select', 'length_select'].includes(selectName),
        )
        .map((selectName) => (
          <ProductParam
            key={selectName}
            selectName={selectName}
            param={product[selectName]}
            value={config[selectName]}
            setValue={(value) => {
              let nextConfig = {
                ...config,
                [selectName]: value,
              };
              let nextExtra = findExtraDisplayInfo(
                product[selectName],
                value,
                config,
              );
              let resp = [null, null];

              if (selectName === 'side_select') {
                alert(
                  `由於您修改了${product[selectName].label}設定, 請重新選擇其餘選項`,
                );
                resp = getDefaultConfigWithExtra({product, side: value});
                nextConfig = resp[0];
                nextExtra = resp[1];
                nextConfig.side_select = value;
              } else if (product[selectName].type === 'master') {
                if (value.material !== config[selectName].material) {
                  resp = getDefaultConfigWithExtra({
                    product,
                    material: value.material,
                  });

                  nextConfig = resp[0];
                  nextExtra = resp[1];
                  nextConfig.side_select = config.side_select;
                }
              }

              onChange(nextConfig, nextExtra);
            }}
            side={config['side_select']}
            config={config}
            viewOnly={viewOnly}
          />
        ))}

      {selectNames.includes('width_select') &&
        selectNames.includes('length_select') && (
          <ProductSizeParam
            product={product}
            value={{
              width_select: config['width_select'],
              length_select: config['length_select'],
            }}
            setValue={(values) => {
              let nextConfig = {
                ...config,
                ...values,
              };

              onChange(nextConfig);
            }}
            viewOnly={viewOnly}
          />
        )}
    </Wrapper>
  );
}

const Wrapper = styled.div``;
